
import { computed, defineComponent, PropType, ref, toRef, watch } from "vue";
import { useField } from "vee-validate";

type Size = "sm" | "lg" | "default";

export default defineComponent({
  name: "file-field",
  props: {
    name: {
      type: String,
      required: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: "*",
    },
    formControl: {
      type: String as PropType<Size>,
      default: "default",
    },
    placeholder: {
      type: String,
      default: "Pilih Dokumen",
    },
    clearField: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    iconOnly: {
      type: Boolean,
      defaut: false,
    },
    showIconPlaceholder: {
      type: Boolean,
      default: false,
    }
  },
  setup(props, { emit }) {
    const file = ref<HTMLInputElement | null>();

    const openDialog = () => {
      if (file.value) file.value.click();
    };

    const _filename = ref("");

    const filename = computed(() => {
      if (_filename.value == "") return props.placeholder;
      else return _filename.value;
    });

    watch(
      () => props.clearField,
      () => {
        if (props.clearField) {
          _filename.value = "";
          value.value = undefined;
          emit("cleared-field");
        }
      }
    );

    const handleChange = (event: Event) => {
      if (event.target) {
        const ele = event.target as HTMLInputElement;
        if (ele.files) {
          const len = ele.files.length;
          let names: string[] = [];

          for (let i = 0; i < len; i++) {
            names.push(ele.files[i].name);
          }

          _filename.value = names.join(", ");

          // Toggle validation
          if (len === 0) value.value = undefined;
          else if (props.multiple) value.value = ele.files;
          else value.value = ele.files[0];

          console.log('FileField :: handleChange :: value',value.value);

          emit("change", event);
          emit('change2', value.value);
        }
      }
    };

    function isRequired(value) {
      return true;
    }

    const inputGroupSize = computed(() => {
      if (props.formControl == "default") return "input-group";
      else if (props.formControl == "sm") return "input-group input-group-sm";
      else return "input-group input-group-lg";
    });

    const nameRef = toRef(props, "name");
    const { errorMessage, value } = useField(nameRef, isRequired);

    return {
      errorMessage,
      value,
      file,
      nameRef,
      filename,
      inputGroupSize,
      openDialog,
      handleChange,
    };
  },
});
